import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-1e7c1978"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "compilation"
};
const _hoisted_3 = {
  class: "compilation-top"
};

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Редактировать подборку ");

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Копировать ссылку:", -1));

const _hoisted_6 = {
  class: "compilation-title"
};
const _hoisted_7 = {
  class: "compilation-item"
};
const _hoisted_8 = {
  class: "compilation-item__img",
  style: {
    "position": "relative"
  }
};
const _hoisted_9 = {
  key: 0,
  class: "moderation-status"
};
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "compilation-item__desc"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Автор подборки:", -1));

const _hoisted_13 = {
  class: "compilation-item__author"
};
const _hoisted_14 = {
  class: "compilation-item__author-img"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "compilation-item__author-title"
};
const _hoisted_17 = {
  class: "compilation-item__text"
};
const _hoisted_18 = {
  class: "greed"
};
const _hoisted_19 = {
  class: "flex-row"
};
const _hoisted_20 = {
  class: "item"
};
const _hoisted_21 = {
  class: "item-img"
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  class: "item-title"
};
const _hoisted_24 = {
  class: "item-text"
};
const _hoisted_25 = {
  class: "item"
};
const _hoisted_26 = {
  class: "item-img"
};
const _hoisted_27 = ["src"];
const _hoisted_28 = {
  class: "item-title"
};
const _hoisted_29 = {
  class: "item-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_EditPen = _resolveComponent("EditPen");

  const _component_el_icon = _resolveComponent("el-icon");

  const _component_router_link = _resolveComponent("router-link");

  const _component_Link = _resolveComponent("Link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_router_link, {
    to: {
      name: 'profile/compilation-update',
      params: {
        id: _ctx.$route.params.id
      }
    },
    class: "compilation-edit"
  }, {
    default: _withCtx(() => [_hoisted_4, _createVNode(_component_el_icon, {
      class: "icon-edit"
    }, {
      default: _withCtx(() => [_createVNode(_component_EditPen)]),
      _: 1
    })]),
    _: 1
  }, 8, ["to"]), _createElementVNode("a", {
    style: {
      "cursor": "pointer"
    },
    onClick: _cache[0] || (_cache[0] = $event => $options.handlerCopy($data.Compilation.accessLink)),
    class: "compilation-copy"
  }, [_createElementVNode("span", null, [_hoisted_5, _createTextVNode(" " + _toDisplayString($data.Compilation.accessLink), 1)]), _createVNode(_component_el_icon, {
    class: "icon-link"
  }, {
    default: _withCtx(() => [_createVNode(_component_Link)]),
    _: 1
  })])])]), _createElementVNode("div", _hoisted_6, _toDisplayString($data.Compilation.name), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [$data.Compilation.status_id === 4 ? (_openBlock(), _createElementBlock("div", _hoisted_9, "На модерации")) : _createCommentVNode("", true), _createElementVNode("img", {
    class: "compilation-item__img-image",
    src: $data.Compilation.thumbWithPath,
    alt: ""
  }, null, 8, _hoisted_10)]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
    src: _ctx.user('photo'),
    alt: ""
  }, null, 8, _hoisted_15)]), _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.user('name')), 1)]), _createElementVNode("div", _hoisted_17, _toDisplayString($data.Compilation.description), 1)])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.userWorks, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "col-3",
      key: item.id
    }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createElementVNode("img", {
      src: item.thumbWithPath,
      alt: ""
    }, null, 8, _hoisted_22)]), _createElementVNode("div", _hoisted_23, _toDisplayString(item.author), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(item.name), 1)])]);
  }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.Compilation.works, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "col-3",
      key: item.id
    }, [_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("img", {
      src: item.thumbWithPath,
      alt: ""
    }, null, 8, _hoisted_27)]), _createElementVNode("div", _hoisted_28, _toDisplayString(item.author.name), 1), _createElementVNode("div", _hoisted_29, _toDisplayString(item.name), 1)])]);
  }), 128))])])]);
}